import { createAction } from '@ngrx/store';

export const init = createAction('[Events] init');
